import { render, staticRenderFns } from "./allrequests.vue?vue&type=template&id=cb9a649e&scoped=true"
import script from "./allrequests.vue?vue&type=script&lang=js"
export * from "./allrequests.vue?vue&type=script&lang=js"
import style0 from "./allrequests.vue?vue&type=style&index=0&id=cb9a649e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9a649e",
  null
  
)

export default component.exports